import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";

export default function getClientDocumentUrl(typeId: string, id: string) {
    return LcabApiRequest.getUrl(`/api/documents/scan/${typeId}/${id}/download`);
}